import React, { useRef, useState, useEffect } from 'react';
import { v4 as uuidv4 } from 'uuid'; //uuidv4()
import audio from '../../audios/camera-click.mp3';
import { useCookies } from 'react-cookie';
import '../tabs.css';

import config from '../../../config.js'
import { fiscalYears, currentFiscalYear } from '../../../services/FiscalYears';

import {
    MissingInfoModalComp, //used to be ErrorModal
    LabFormInputsComp, //used to be formInputs
    TempMessageModalComp, //used to be Loading and Success
    PhotoGridComp, // use to be PhotoGrid
    ConfirmationModalComp // used to be ExistingSampleModal and ExistingSampleRangeModal
} from '../../../components';

const initialState = {
    fiscalYear: currentFiscalYear,
    lab: '',
    labNumber: '',
    labNumberEnd: '',
    sampleType: '',
};

const videoConstraints = {
    width: 1280,
    height: 720,
    facingMode: "environment"
};

const sound = new Audio(audio)

// How long to wait after the last change to the lab/sample fields before looking
// for existing samples, so a partially typed lab number is never searched.
const SEARCH_DEBOUNCE_MS = 600;


const sampleCapQueueURI = config.urls.queue_url
const sampleCapGQLURI = config.urls.gql_url

const Capture = (props) => {
    const { userEmail, handleShowModal } = props;

    const fileInput = useRef();
    const [autoIncrement, setAutoIncrement] = useState(true);
    const [images, setImages] = useState([]);
    const [errors, setErrors] = useState({});
    const [fileInputKey, setFileInputKey] = useState(1);
    const [formData, setFormData] = useState(initialState);
    const [labLocked, setLabLocked] = useState(false);
    const [labRange, setLabRange] = useState(false);
    const [loading, setLoading] = useState(false);
    const [sampleTypeLocked, setSampleTypeLocked] = useState(false);
    const [fiscalYearLocked, setFiscalYearLocked] = useState(false);
    const [showErrorModal, setShowErrorModal] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);
    const [existingSample, setExistingSample] = useState(false);
    const [openConfirmationModal, setOpenConfirmationModal] = useState(false)// use to be: const [existingSampleModalOpen, setESMOpen] = useState(false); // const [existingRangeSamplesModal, setERSModal] = useState(false);
    const [optionalThirdButtonLabel, setOptionalThirdButtonLabel] = useState("")
    const [appendLength, setAppendLength] = useState(0); //[numberErrorTap, setNET]
    const [placeHolder, setPlaceHolder] = useState("")
    const [existingPic, setExistingPic] = useState("")
    const [existingSampleID, setExistingSampleID] = useState("")
    const [existingSampleTokens, setExistingSampleTokens] = useState([])
    const [existingSampleIDsRange, setExistingSampleIDsRange] = useState([])
    const [advanceOptionsLabel, setAdvanceOptionsLabel] = useState("Lab Number Auto Advance");
    const [advanceOptionsModal, setAdvanceOptionsModal] = useState(false);
    const [showAutoPhotoTools, setShowAutoPhotoTools] = useState(false);
    const [autoPicTimeInterval, setAutoPicTimeInterval] = useState(5);
    const [takingAutoPictures, setTakingAutoPictures] = useState(false);
    const [cookies, setCookie] = useCookies(['user']);
    const [lookingForExistingSamples, setLookingForExistingSamples] = useState(false)
    const [isLoadingFetch, setIsLoadingFetch] = useState(false)
    // Only the newest existing-sample search is allowed to write to state. Every search
    // bumps this id, and a response carrying a stale id is discarded instead of
    // overwriting the result of a newer search.
    const searchRequestIdRef = useRef(0);
    const searchDebounceRef = useRef(null);
    const lookingTimeoutRef = useRef(null);

    const webcamRef = useRef(null);

    const handleCookie = () => {
        setCookie('lab', formData.lab, { path: '/' });
        setCookie('sampleCapSampleType', formData.sampleType, { path: '/' });
        setCookie('labLocked', labLocked, { path: '/' });
        setCookie('sampleTypeLocked', sampleTypeLocked, { path: '/' });
        setCookie('fiscalYearLocked', fiscalYearLocked, { path: '/' });
        setCookie('autoIncrement', autoIncrement, { path: '/' });
        setCookie('labNumber', formData.labNumber, { path: '/' });
        setCookie('labRange', labRange, { path: '/' });
        setCookie('showAutoPhotoTools', showAutoPhotoTools, { path: '/' });
        setCookie('autoPicTimeInterval', autoPicTimeInterval, { path: '/' });
        setCookie('advanceOptionsLabel', advanceOptionsLabel, { path: '/' });
    }
    // The criteria are passed in rather than read off formData so that the response can
    // be checked against the exact lab number it was searched with.
    async function getSampleCapturesByLabNumbers(criteria) {
        const requestId = searchRequestIdRef.current + 1;
        searchRequestIdRef.current = requestId;

        const isRangeSearch = criteria.labNumberEnd !== "" && criteria.labNumberEnd !== null && criteria.labNumberEnd !== undefined;

        setLookingForExistingSamples(true)
        setIsLoadingFetch(true)
        let getSampleCapturesByLabNumbersFetchQuery = `{
            getSampleCapturesByLabNumbers(
                fiscalYear:${JSON.stringify(criteria.fiscalYear)},
                lab:${JSON.stringify(criteria.lab)},
                sampleType: ${JSON.stringify(criteria.sampleType)},
                labNumber: ${criteria.labNumber}`;

        if (isRangeSearch) {
            getSampleCapturesByLabNumbersFetchQuery += `, labNumberEnd:${criteria.labNumberEnd}`
        }

        getSampleCapturesByLabNumbersFetchQuery += `) {
                ok
                sampleCaptures{
                    fiscalYear
                    id
                    lab
                    labNumber
                    photos {
                        id
                        token
                        url
                    }
                    sampleType
                }
            }
        }
    `;
        try {
            const getSampleCapturesByLabNumbersFetch = await fetch(sampleCapGQLURI,
                {
                    method: 'POST',
                    body: JSON.stringify({ query: getSampleCapturesByLabNumbersFetchQuery }),
                    headers: { 'Content-type': 'application/json' }
                }
            );
            const capRangeData = await getSampleCapturesByLabNumbersFetch.json();

            // A newer search was started while this one was in flight. That newer search
            // is the one matching what is on screen, so this response is thrown away.
            if (requestId !== searchRequestIdRef.current) {
                return;
            }

            const sampleCaptures = capRangeData
                && capRangeData.data
                && capRangeData.data.getSampleCapturesByLabNumbers
                && capRangeData.data.getSampleCapturesByLabNumbers.sampleCaptures;

            if (!sampleCaptures) {
                setExistingPic("")
                setExistingSampleIDsRange([])
                return;
            }

            // Never accept a sample whose lab number is not the one that was searched for.
            const matchingCaptures = sampleCaptures.filter(x => isRangeSearch
                ? (Number(x.labNumber) >= Number(criteria.labNumber) && Number(x.labNumber) <= Number(criteria.labNumberEnd))
                : Number(x.labNumber) === Number(criteria.labNumber));

            if (matchingCaptures.length === 0) {
                setExistingPic("")
                setExistingSampleIDsRange([])
            } else if (!isRangeSearch) {
                setExistingPic(matchingCaptures[0]);
                setExistingSampleIDsRange([])
            } else {
                setExistingPic("")
                let newRange = [];
                matchingCaptures.forEach(x => {
                    let photos = [];
                    x.photos.forEach(y => {
                        photos.push({ "token": y.token })
                    })
                    newRange.push({ "id": x.id, "sampleType": x.sampleType, "lab": x.lab, "labNumber": x.labNumber, "fiscalYear": x.fiscalYear, "photoTokens": photos })
                })
                console.log(newRange)
                setExistingSampleIDsRange(newRange);
            }
        } catch (error) {
            console.log('existing sample search failed: ', error)
            if (requestId === searchRequestIdRef.current) {
                setExistingPic("")
                setExistingSampleIDsRange([])
            }
        } finally {
            // Keep Submit disabled while a newer search is still running.
            if (requestId === searchRequestIdRef.current) {
                setIsLoadingFetch(false)
            }
        }
    }

    const onChange = (e, arg) => {
        e.preventDefault();
        if (arg === "sampleTypeLocked" || arg === "labLocked") {
            delete errors[e];
            setErrors(errors);
        } else {
            const { name, value } = e.target;
            if ((name === 'labNumber' || name === 'labNumberEnd') && value.length) {
                setFormData({
                    ...formData,
                    [name]: parseInt(value),
                });
                delete errors.labNumber
                delete errors.labNumberEnd
                setErrors(errors)
            } else {
                setFormData({
                    ...formData,
                    [name]: value,
                });
                delete errors[name];
                setErrors(errors);
            }
        }
        setPlaceHolder(formData);
    };

    const handlePhotoAddToGrid = (photoString) => {
        setImages([...images, {
            id: uuidv4(),
            image: photoString
        }]);
        delete errors.images;
        setErrors(errors);
    }

    const handlePhotoAddToGridFileInput = () => {
        if (
            fileInput.current
            && fileInput.current.files
            && fileInput.current.files.length > 0
        ) {
            const file = fileInput.current.files[0];

            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                setImages([...images, {
                    id: uuidv4(),
                    image: reader.result,
                    file: fileInput.current.files[0],
                }]);
            };

            delete errors.images;
            setErrors(errors);
        }
    };

    const capture = () => {
        const imageSrc = webcamRef.current.getScreenshot();
        sound.play()
        handlePhotoAddToGrid(imageSrc)
    }

    const handlePhotoDelete = imageId => {
        setImages([...images.filter(el => el.id !== imageId)]);
        setFileInputKey(fileInputKey + 1);
    };

    const handleFullReset = () => {
        setImages([]);
        setFileInputKey(fileInputKey + 1);
        setFormData({ ...initialState });
        setAutoIncrement(false);
        setErrors([]);
        setLabLocked(false);
        setSampleTypeLocked(false);
        setFiscalYearLocked(false);
        setExistingPic("")
        setExistingSampleID("")
        setExistingSampleTokens([])
        setExistingSample(false)
        setAppendLength(0)
        setExistingSampleIDsRange([])
        setTakingAutoPictures(false)
    };

    const handleResetAfterSubmit = () => {
        const getLabNumber = key => {
            if (labRange) {
                return initialState[key];
            }

            if (autoIncrement) {
                if (key === 'labNumber') {
                    return Number(formData[key]) + 1;
                }
            }

            return initialState[key];
        };
        if (formData.lab === 'Hastings' && showAutoPhotoTools === true) {
            const currentLabNum = parseInt(formData.labNumber)
            const newLabNumber = currentLabNum + 1;
            setFormData({
                fiscalYear: !fiscalYearLocked ? initialState.fiscalYear : formData.fiscalYear,
                lab: !labLocked ? initialState.lab : formData.lab,
                sampleType: !sampleTypeLocked ? initialState.sampleType : formData.sampleType,
                labNumber: newLabNumber,
                labNumberEnd: '',
            });

            setTimeout(() => {
                setFileInputKey(fileInputKey + 1);
                setImages([]);
            }, (autoPicTimeInterval - 1) * 1000);
        } else {
            setFormData({
                fiscalYear: !fiscalYearLocked ? initialState.fiscalYear : formData.fiscalYear,
                lab: !labLocked ? initialState.lab : formData.lab,
                sampleType: !sampleTypeLocked ? initialState.sampleType : formData.sampleType,
                labNumber: getLabNumber('labNumber'),
                labNumberEnd: getLabNumber('labNumberEnd'),
            });
            setImages([]);
            setErrors({});
            setFileInputKey(fileInputKey + 1);
            setExistingPic("")
            setExistingSampleID("")
            setExistingSampleTokens([])
            setExistingSample(false)
            setAppendLength(0)
            setExistingSampleIDsRange([])
        }
    };

    const handleSubmit = async e => {
        e.preventDefault();

        const formErrors = {};

        if (!formData.lab) {
            formErrors.lab = { error: true, message: 'Lab is required' };
        }

        if (!formData.sampleType) {
            formErrors.sampleType = { error: true, message: 'Sample Type is required' };
        }

        if (!formData.fiscalYear) {
            formErrors.fiscalYear = { error: true, message: 'Year is required' };
        }

        if (labRange) {
            if (!formData.labNumber
                || (labRange && !formData.labNumberEnd)
                || (labRange && (Number(formData.labNumber) >= Number(formData.labNumberEnd)))
            ) {
                formErrors.labNumber = { error: true, message: 'Lab Range is invalid' };
                formErrors.labNumberEnd = { error: true };
            }
            else if (((Number(formData.labNumberEnd) - Number(formData.labNumber) > 200))) {
                formErrors.labNumber = { error: true, message: 'Cannot include more than 200 samples in a Range' };
                formErrors.labNumberEnd = { error: true };
            }
        }

        if (!labRange) {
            if (!formData.labNumber) {
                formErrors.labNumber = { error: true, message: 'Lab Number is required' };
            }
        }

        if (images.length === 0) {
            formErrors.images = { error: true, message: 'At least 1 photo is required' };
        }

        if (Object.keys(formErrors).length > 0) {
            //   console.log('error', formErrors);
            setShowErrorModal(true);
            setErrors(formErrors);
            return;
        }
        if (existingSample === true && existingSampleIDsRange.length === 0) {
            handleOpenConfirmationModal()  //   handleOpenNETModal();
            setOptionalThirdButtonLabel("APPEND")
        } else if (existingSample === true && existingSampleIDsRange.length > 0) {
            handleOpenConfirmationModal(); //handleOpenERSModal();
        } else if (existingSample === false) {

            setLoading(true);

            const photos = images.map(({ image }) => image.split("data:image/jpeg;base64,").pop());
            const variables = { environment: config.env, data: { ...formData, photos, userEmail } };

            await fetch(sampleCapQueueURI, { method: 'POST', body: JSON.stringify({ sampleCap: JSON.stringify(variables) }), headers: { 'Content-Type': 'application/json' } });

            handleResetAfterSubmit();
            setLoading(false);
            setShowSuccess(true);

            setTimeout(() => {
                setShowSuccess(false);
            }, 1500);
        }
    };

    const handleExistingSampleSubmit = async e => {
        setLoading(true);
        setOpenConfirmationModal(false)
        const photos = images.map(({ image }) => image.split("data:image/jpeg;base64,").pop());
        const variables = { environment: config.env, data: { ...formData, photos, numberErrorTap: appendLength, existingSampleID, overwrite: false, userEmail } };

        await fetch(sampleCapQueueURI, { method: 'POST', body: JSON.stringify({ sampleCap: JSON.stringify(variables) }), headers: { 'Content-Type': 'application/json' } });

        setLoading(false);
        setShowSuccess(true);
        setTimeout(() => {
            setShowSuccess(false);
        }, 1500);
        handleResetAfterSubmit();
    }

    const handleOverWrite = async e => {
        setLoading(true);
        setOpenConfirmationModal(false)
        const photos = images.map(({ image }) => image.split("data:image/jpeg;base64,").pop());
        let variables;
        if (existingSampleIDsRange.length === 0) {
            variables = { environment: config.env, data: { ...formData, photos, existingSampleID, existingSampleTokens: JSON.stringify(existingSampleTokens), overwrite: true, userEmail } };
        } else {
            variables = { environment: config.env, data: { ...formData, photos, overwrite: true, overwriteWithinRangeIDs: JSON.stringify(existingSampleIDsRange), userEmail } };
        }

        await fetch(sampleCapQueueURI, { method: 'POST', body: JSON.stringify({ sampleCap: JSON.stringify(variables) }), headers: { 'Content-Type': 'application/json' } });

        setLoading(false);
        setShowSuccess(true);
        setTimeout(() => {
            setShowSuccess(false);
        }, 1500);
        handleResetAfterSubmit();
    }

    const handleRange = () => {
        setLabRange(true);
        setAutoIncrement(false);

        delete errors.labNumber;
        delete errors.labNumberEnd;
        setErrors(errors);
        setShowErrorModal(false);

        setFormData({
            ...formData,
            labNumber: initialState.labNumber,
            labNumberEnd: initialState.labNumberEnd,
        });
    };

    const startAutoPictures = () => {
        sound.load();
        const formErrors = {};

        if (!formData.lab) {
            formErrors.lab = { error: true, message: 'Lab is required' };
        }

        if (!formData.sampleType) {
            formErrors.sampleType = { error: true, message: 'Sample Type is required' };
        }

        if (!formData.fiscalYear) {
            formErrors.fiscalYear = { error: true, message: 'Year is required' };
        }

        if (!formData.labNumber) {
            formErrors.labNumber = { error: true, message: 'Lab Number is required' };
        }

        if (autoPicTimeInterval < 5) {
            formErrors.interval = { error: true, message: 'Time Interval must be at least 5 seconds' };
        }

        if (!labLocked) {
            formErrors.labLocked = { error: true, message: 'Lab must be locked in Auto Picture mode' };
        }

        if (!sampleTypeLocked) {
            formErrors.sampleTypeLocked = { error: true, message: 'Sample Type must be locked in Auto Picture mode' };
        }


        if (Object.keys(formErrors).length > 0) {
            console.log('error', formErrors);
            setShowErrorModal(true);
            setErrors(formErrors);
            return;
        }

        if (Object.keys(formErrors).length === 0 && autoPicTimeInterval >= 5) {
            setTakingAutoPictures(true)
        } else {
            console.log("missing info or interval < 5")
        }
    }

    const stopAutoPictures = () => {
        setTakingAutoPictures(false)
    }

    const autoSubmitPics = async () => {
        let existing;
        const imageSrc = webcamRef.current.getScreenshot();
        sound.play()
        let photoStringToUse;
        handlePhotoAddToGrid(imageSrc);
        photoStringToUse = imageSrc;
        const getSampleCapturesByLabNumbersFetchQuery = `{
            getSampleCapturesByLabNumbers(
                fiscalYear:${JSON.stringify(formData.fiscalYear)},
                lab:${JSON.stringify(formData.lab)},
                sampleType: ${JSON.stringify(formData.sampleType)},
                labNumber: ${formData.labNumber}
            ) {
                ok
                sampleCaptures{
                    fiscalYear
                    id
                    lab
                    labNumber
                    photos {
                        id
                        token
                        url
                    }
                    sampleType
                }
            }
        }
    `;
        const existingFetch = await fetch(sampleCapGQLURI, { method: 'POST', body: JSON.stringify({ query: getSampleCapturesByLabNumbersFetchQuery }), headers: { 'Content-type': 'application/json' } });
        const existingJson = await existingFetch.json();
        existing = existingJson.data.getSampleCapturesByLabNumbers.sampleCaptures.length;


        if (existing > 0) {
            let eToken = [];
            setExistingSampleID(existingJson.data.getSampleCapturesByLabNumbers.sampleCaptures[0].id)
            existingJson.data.getSampleCapturesByLabNumbers.sampleCaptures[0].photos.forEach(x => {
                eToken.push(x.token)
            })
            setExistingSampleTokens({ fiscalYear: existingJson.data.getSampleCapturesByLabNumbers.sampleCaptures[0].fiscalYear, sampleType: existingJson.data.getSampleCapturesByLabNumbers.sampleCaptures[0].sampleType, lab: existingJson.data.getSampleCapturesByLabNumbers.sampleCaptures[0].lab, labNumber: existingJson.data.getSampleCapturesByLabNumbers.sampleCaptures[0].labNumber, photoTokens: eToken })
            setTakingAutoPictures(false)
            handleOpenConfirmationModal()
            setOptionalThirdButtonLabel("APPEND")
        }
        else {
            let photos = [];
            photos.push(photoStringToUse.split("data:image/jpeg;base64,").pop())
            const variables = { environment: config.env, data: { ...formData, photos, userEmail } };

            await fetch(sampleCapQueueURI, { method: 'POST', body: JSON.stringify({ sampleCap: JSON.stringify(variables) }), headers: { 'Content-Type': 'application/json' } });

            const currentLabNum = parseInt(formData.labNumber)
            const newLabNumber = currentLabNum + 1;

            setShowSuccess(true);
            setFormData({
                ...formData,
                ...!labLocked && { lab: initialState.lab },
                ...!sampleTypeLocked && { sampleType: initialState.sampleType },
                ...!fiscalYearLocked && { fiscalYear: initialState.fiscalYear },
                labNumber: newLabNumber,
                labNumberEnd: '',
            });

            setTimeout(() => {
                setErrors({});
                setFileInputKey(fileInputKey + 1);
                setAppendLength(0)
                setImages([]);
                setShowSuccess(false);
            }, (autoPicTimeInterval - 1) * 1000);
        }

    }

    const handleCloseError = () => setShowErrorModal(false);
    //before:
    // const handleOpenNETModal = () => setESMOpen(true);
    // const handleOpenERSModal = () => setERSModal(true);
    //new: 
    const handleOpenConfirmationModal = () => setOpenConfirmationModal(true);
    const handleCloseConfirmationModal = () => setOpenConfirmationModal(false);
    const handleAdvanceOptionsLabel = (option) => setAdvanceOptionsLabel(option);

    const handleSetAdvanceOptions = (option) => {
        switch (option) {
            case 'Range':
                handleRange();
                setShowAutoPhotoTools(false);
                setAutoIncrement(false);
                break;

            case 'Auto Pictures':
                setShowAutoPhotoTools(true);
                setAutoIncrement(true);
                setLabRange(false);
                break;

            default:
                // Lab Number Auto Advance
                setAutoIncrement(true);
                setLabRange(false);
                setShowAutoPhotoTools(false);
                break;
        }
    }

    const handleSetAutoPicTimeInterval = (e) => {
        setAutoPicTimeInterval(e.target.value)
    }

    const preventMinus = (e) => {
        if (e.code === 'Minus' || e.which > 57 || e.which === 32) {
            e.preventDefault();
        }
    };

    useEffect(() => {
        if (cookies.lab && cookies.sampleCapSampleType && cookies.labLocked && cookies.sampleTypeLocked && cookies.fiscalYearLocked && cookies.labNumber && cookies.labRange
            && cookies.showAutoPhotoTools && cookies.autoIncrement && cookies.autoPicTimeInterval && cookies.advanceOptionsLabel) {
            setFormData((prevState) => {
                return { ...prevState, lab: cookies.lab, sampleType: cookies.sampleCapSampleType, labNumber: cookies.labNumber }
            });
            if (cookies.labLocked === "false") {
                setLabLocked(false);
            } else {
                setLabLocked(true);
            }
            if (cookies.sampleTypeLocked === "false") {
                setSampleTypeLocked(false);
            } else {
                setSampleTypeLocked(true);
            }
            if (cookies.fiscalYearLocked === "false") {
                setFiscalYearLocked(false);
            } else {
                setFiscalYearLocked(true);
            }
            if (cookies.labRange === "false") {
                setLabRange(false);
            } else {
                setLabRange(true);
            }
            if (cookies.showAutoPhotoTools === "false") {
                setShowAutoPhotoTools(false);
            } else {
                setShowAutoPhotoTools(true);
                setFormData((prevState) => {
                    return { ...prevState, labNumber: parseInt(cookies.labNumber) }
                });
            }
            if (cookies.autoIncrement === "false") {
                setAutoIncrement(false);
            } else {
                setAutoIncrement(true);
            }
            setAutoPicTimeInterval(cookies.autoPicTimeInterval);
            setAdvanceOptionsLabel(cookies.advanceOptionsLabel || "Lab Number Auto Advance")
        }
        // eslint-disable-next-line 
    }, [])

    useEffect(() => {
        if (formData !== "" && formData !== placeHolder) {
            // Any change to the criteria invalidates the search that is already in flight
            // along with whatever it found for the previous lab number. Without this, a
            // response for a partially typed number (5961) could land after the response
            // for the full number (59610) and leave that sample staged for overwrite.
            searchRequestIdRef.current = searchRequestIdRef.current + 1;
            clearTimeout(searchDebounceRef.current);
            clearTimeout(lookingTimeoutRef.current);
            setExistingPic("")
            setExistingSampleIDsRange([])

            let variables = {};
            if (formData.labNumber === "" || (formData.labNumberEnd === "" && formData.labNumber === "")) {
                variables = {};
            } else if (formData.labNumberEnd !== "" && formData.labNumber !== "" && (formData.labNumberEnd > formData.labNumber)) {
                variables = {
                    fiscalYear: formData.fiscalYear,
                    lab: formData.lab,
                    labNumber: parseInt(formData.labNumber),
                    sampleType: formData.sampleType,
                    labNumberEnd: parseInt(formData.labNumberEnd)
                };
            } else if (formData.labNumberEnd === "" && formData.labNumber !== "") {
                variables = {
                    fiscalYear: formData.fiscalYear,
                    lab: formData.lab,
                    labNumber: parseInt(formData.labNumber),
                    sampleType: formData.sampleType
                };
            }

            const hasAllCriteria = !!(variables.fiscalYear && variables.labNumber && variables.lab && variables.sampleType);
            const rangeIsInvalid = !!(variables.labNumberEnd && ((variables.labNumberEnd - variables.labNumber > 200) || (variables.labNumberEnd <= variables.labNumber)));

            if (!hasAllCriteria || rangeIsInvalid) {
                if (hasAllCriteria) {
                    handleCookie()
                }
                setIsLoadingFetch(false)
                setLookingForExistingSamples(false)
                return;
            }

            // Block Submit from the moment the criteria change until the search that
            // matches them has come back, so a sample can't be submitted against a
            // result that belongs to a different lab number.
            setLookingForExistingSamples(true)

            searchDebounceRef.current = setTimeout(() => {
                getSampleCapturesByLabNumbers(variables);
                handleCookie();
            }, SEARCH_DEBOUNCE_MS);

            return () => clearTimeout(searchDebounceRef.current);
        }
        // eslint-disable-next-line
    }, [formData])

    useEffect(() => {
        clearTimeout(lookingTimeoutRef.current)
        if (!isLoadingFetch) {
            lookingTimeoutRef.current = setTimeout(() => {
                setLookingForExistingSamples(false)
            }, 800);
        }
    }, [isLoadingFetch])

    useEffect(() => {
        if (existingPic !== "" && existingSampleIDsRange.length === 0) {
            if (existingPic && existingPic.photos !== null) {
                setAppendLength(existingPic.photos.length);
                setExistingSample(true)
                setExistingSampleID(existingPic.id)
                let tokens = [];
                existingPic.photos.forEach(x => {
                    tokens.push(x.token)
                })
                console.log('pic exists', existingPic)
                setExistingSampleTokens({ fiscalYear: existingPic.fiscalYear, sampleType: existingPic.sampleType, lab: existingPic.lab, labNumber: existingPic.labNumber, photoTokens: tokens });
            } else if (existingPic && existingPic.photos === null) {
                setExistingSampleID("")
                setExistingSampleTokens([])
                setExistingSample(false)
                setAppendLength(0)
            } else {
                setExistingSampleID("")
                setExistingSampleTokens([])
                setExistingSample(false)
                setAppendLength(0)
            }
        } else if (existingSampleIDsRange.length > 0 && existingPic === "") {
            setExistingSample(true)
        } else {
            setExistingSampleID("")
            setExistingSampleTokens([])
            setExistingSample(false)
            setAppendLength(0)
        }
    }, [existingPic, existingSampleIDsRange])

    useEffect(() => {
        if (takingAutoPictures === true && images.length === 0) {
            const interval = setInterval(async () => {
                autoSubmitPics();
            }, 1000)
            return () => clearInterval(interval);
        }
        // eslint-disable-next-line
    }, [takingAutoPictures, formData, images])


    return (
        <>
            {loading && <TempMessageModalComp isOpen={loading} isSuccessMessage={false} message={"Loading"} />}
            {showSuccess && <TempMessageModalComp isOpen={showSuccess} isSuccessMessage={true} message={"Success"} />}
            {showErrorModal && Object.keys(errors).length > 0 && (<MissingInfoModalComp missingInfo={errors} handleCloseModal={handleCloseError} isOpen={showErrorModal} />)}
            <form className="capture-form" encType={"multipart/form/data"}>
                <div style={{ "marginTop": "5px" }}>
                    <div className="card mx-auto">
                        <div className="card-body" style={{ marginTop: "-14px" }}>
                            <ConfirmationModalComp
                                isOpen={openConfirmationModal}
                                handleCloseModal={handleCloseConfirmationModal}
                                handleSubmit={handleOverWrite}
                                title={"OVERWRITING WARNING"}
                                message={optionalThirdButtonLabel === "" ? ["THERE ARE IMAGES SAVED UNDER THE LAB/SAMPLETYPE/LABNUMBER.", "YOU CAN OVERWRITE THE IMAGES SAVED OR APPEND A 1 TO THE FILENAME TO PREVENT FROM DELETING NEEDED IMAGES.", "*APPENDED IMAGES WILL SHOW UP IN LIMS.*"] : ["There are sample with images saved in the range you have entered are you sure you want to overwrite them?"]}
                                submitButtonLabel={"OVERWRITE"}
                                extendedMessage={
                                    <div >
                                        <p style={{ color: 'red' }}>{formData?.labNumberEnd ? existingSampleIDsRange.length > (formData?.labNumberEnd || 0) - formData.labNumber : existingSampleTokens.length > 1 && "There are more samples to be overwritten than in the range. Please double check and call IT if the samples to overwrite don't match."}</p>
                                        <label className='sample-overwrite-label'>{formData?.labNumberEnd ? existingSampleIDsRange.length : 1} Sample(s) Found to Overwrite:</label>
                                        <div className='em-box'>
                                            <table className='existing-samples-table'>
                                                <th>Lab No.</th>
                                                <th>Lab</th>
                                                <th>Type</th>
                                                <th>No. Imgs</th>
                                                <th>SampleID</th>

                                                {existingSampleIDsRange.map(sample =>
                                                    <tr>
                                                        <td>{sample.labNumber}</td>
                                                        <td>{sample.lab.charAt(0)}</td>
                                                        <td>{sample.sampleType.slice(0, 4)}</td>
                                                        <td>{sample.photoTokens.length}</td>
                                                        <td>{sample.id}</td>
                                                    </tr>
                                                )}
                                                {existingSampleTokens && !existingSampleIDsRange?.length && openConfirmationModal &&
                                                    <tr>
                                                        <td>{existingSampleTokens?.labNumber}</td>
                                                        <td>{existingSampleTokens?.lab.charAt(0)}</td>
                                                        <td>{existingSampleTokens?.sampleType.slice(0, 4)}</td>
                                                        <td>{existingSampleTokens?.photoTokens?.length}</td>
                                                        <td>{existingSampleID}</td>
                                                    </tr>
                                                }
                                            </table>
                                        </div>
                                    </div>
                                }
                                optionalThirdButtonLabel={optionalThirdButtonLabel}
                                optionalThirdOption={handleExistingSampleSubmit}
                                setOptionalThirdButtonLabel={setOptionalThirdButtonLabel}
                            />
                            <LabFormInputsComp
                                errors={errors}
                                formData={formData}
                                yearsList={fiscalYears.capture}
                                labList={["Amarillo", "Dodge City", "Hastings"]}
                                sampleTypeList={["Feed", "Fertilizer", "Plant", "Soil", "Environmental", "Other"]}
                                onChange={onChange}
                                preventMinus={preventMinus}
                                withLocksAndRange={{
                                    autoIncrement: {
                                        value: autoIncrement,
                                    },
                                    labLocked: {
                                        setter: setLabLocked,
                                        value: labLocked,
                                    },
                                    labRange: {
                                        value: labRange,
                                    },
                                    sampleTypeLocked: {
                                        setter: setSampleTypeLocked,
                                        value: sampleTypeLocked,
                                    },
                                    fiscalYearLocked: {
                                        setter: setFiscalYearLocked,
                                        value: fiscalYearLocked,
                                    }
                                }}
                                handleAdvanceOptionsLabel={handleAdvanceOptionsLabel}
                                advanceOptionsLabel={advanceOptionsLabel}
                                advanceOptionsModal={advanceOptionsModal}
                                setAdvanceOptionsModal={setAdvanceOptionsModal}
                                handleSetAdvanceOptions={handleSetAdvanceOptions}
                            />
                            {/* <div className="divider" /> */}
                            <hr />
                            {/* Start, stop, interval for auto pictures */}
                            {showAutoPhotoTools &&
                                <div className="auto-photo-controls-div">
                                    <span className='seconds-input '>
                                        <label className='seconds-label'>seconds</label>
                                        <input className="auto-control" type='number' min='5' defaultValue={autoPicTimeInterval} onKeyPress={preventMinus} onChange={(e) => handleSetAutoPicTimeInterval(e)}></input>

                                    </span>
                                    {takingAutoPictures &&
                                        <>
                                            <button disabled className='auto-control secondary'>Start</button>
                                            <button className='auto-control red' onClick={(e) => { e.preventDefault(); stopAutoPictures(); handleCookie() }}>Stop</button>
                                        </>
                                    }
                                    {!takingAutoPictures &&
                                        <>
                                            <button className='auto-control green' onClick={(e) => { e.preventDefault(); startAutoPictures() }}>Start</button>
                                            <button disabled className='auto-control secondary'>Stop</button>
                                        </>
                                    }
                                </div>
                            }
                            <PhotoGridComp
                                images={images}
                                handlePhotoDelete={handlePhotoDelete}
                                handlePhotoEnlarge={handleShowModal}
                                videoConstraints={videoConstraints}
                                webcamRef={webcamRef}
                                showAutoPhotoTools={showAutoPhotoTools}
                                fileInput={fileInput}
                                fileInputKey={fileInputKey}
                                handlePhotoAddToGridFileInput={handlePhotoAddToGridFileInput}
                                errors={errors}
                            />
                        </div>
                    </div>
                </div>
                <div className="sample-capture-button-container">
                    <div className="sample-capture-buttons">
                        <button className="secondary" onClick={(e) => { e.preventDefault(); handleFullReset() }}>Reset</button>
                        {!lookingForExistingSamples &&
                            <button className="submit-button" buttontype="submit" type="primary" onClick={(e) => { handleSubmit(e); }}>Submit</button>
                        }
                        {lookingForExistingSamples &&
                            <button className="disabled-submit-button" type="primary" onClick={(e) => { e.preventDefault() }}>Looking for Existing Samples...</button>
                        }
                        {showAutoPhotoTools &&
                            <button className="green capture-image-button" onClick={(e) => { e.preventDefault(); capture() }}>Capture Image</button>
                        }
                    </div>
                </div>
            </form>
        </>
    )
}

export default Capture;